import styled from 'styled-components'

export const CountdownPg = styled.div`
  background: transparent linear-gradient(90deg, #99cb95 0%, #f2f2be 100%) 0% 0%
    no-repeat padding-box;
  min-height: 100vh;
  text-align: center;

  footer img {
    width: 100%;
    display: block;

  }

  header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 2em 1em;

    .logos {
      margin: .4em;
    }
  }

  .countdown {
    /* flex: 1; */
    align-items: center;
    justify-content: center;
    .card {
      background: transparent
        linear-gradient(180deg, #ffffff 0%, #f2f1f1 81%, #b4b3b3 100%) 0% 0%
        no-repeat padding-box;
      border: 4px solid #ffffff;
      border-radius: 27px;
      opacity: 1;
      /* padding: 1em; */
      color: #454852;
      width: 130px;
      padding: 10px;

      .unit {
        letter-spacing: 1px;
        text-transform: uppercase;
      }

      .number {
        font-weight: bold;
        font-size: 3em;
        letter-spacing: 1px;
      }
    }
  }
`
